<template>
  <listing-layout>
    <h1 slot="heading" class="h2 mb-3">List of Judges</h1>
    <div slot="content">
      <div role="alert" class="alert alert-success" v-if="success">{{ success }}</div>
      <div role="alert" class="alert alert-warning" v-if="error">{{ error }}</div>
      <data-table :dataRows="rows" :dataColumns="columns" :options="options">
        <tableTextTemplate
          slot-scope="{ row }"
          slot="expandedHeader"
          :text="row.first_name + ' ' + row.last_name"
          :link="'Member Profile'"
          :slug="row.id"
          :row="row"
          :options="{ showLinks: true, showPrimary: true }" />
        <div slot-scope="{ row }" slot="expandedRow">
          <ul class="list-unstyled mb-0 pt-2">
            <li>
              <strong>First Name: </strong>
              <tableTextTemplate :text="row.first_name" :row="row" :options="{ inline: true }"/>
            </li>
            <li>
              <strong>Last Name: </strong>
              <tableTextTemplate :text="row.last_name" :row="row" :options="{ inline: true }"/>
            </li>
            <li>
              <strong>Phone number: </strong>
              <tableTextTemplate
                :text="row.judge_phone === null || row.judge_phone === '' ? row.mobile_phone === null ? row.phone === null ?
                  row.secondary_phone : row.phone : row.mobile_phone : row.judge_phone"
                :row="row" />
            </li>
            <li>
              <strong>Suburb: </strong>
              <tableTextTemplate :text="row.suburb" :row="row" />
            </li>
            <li>
              <strong>Zone: </strong>
              <tableTextTemplate :text="rowZone(row.zone_id)" :row="row" />
            </li>
            <li>
              <strong>Judge Status: </strong>
              <tableTextTemplate :text="row.status.charAt(0).toUpperCase() + row.status.substring(1)" :row="row" />
            </li>
            <li>
              <div class="judges-list__actions">
                <div class="mr-1" v-if="!row.is_suspended">
                  <button :class="['btn btn-sm mb-2 mb-lg-0', !processing ? 'btn-primary actions-suspend' : 'btn-primary-dark']" @click.prevent="suspendModal">
                    {{ !processing ? 'Suspend' : '' }}
                    <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
                  </button>
                  <modal v-if="showSuspendModal" @close="showSuspendModal = false">
                    <div slot="body">
                      <div class="alert alert-warning text-center">
                        You are about to suspend the judge {{row.first_name}}.
                        Are you sure?
                      </div>
                      <div class="d-flex justify-content-center">
                        <button class="btn btn-outline-primary" @click.prevent="showSuspendModal = false">Cancel</button>
                        <button class="btn btn-primary ml-2" @click.prevent="suspend(row.id);showSuspendModal = false">Confirm</button>
                      </div>
                    </div>
                  </modal>
                </div>
                <div class="mr-1" v-else>
                  <button :class="['btn btn-sm mb-2 mb-lg-0', !processing ? 'btn-outline-primary actions-end_suspension' : 'btn-primary-dark']" @click.prevent="endSuspensionModal">
                    {{ !processing ? 'End Suspension' : '' }}
                    <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
                  </button>
                  <modal v-if="showEndSuspensionModal" @close="showEndSuspensionModal = false">
                    <div slot="body">
                      <div class="alert alert-warning text-center">
                        You are about to end suspension the judge {{row.first_name}}.
                        Are you sure?
                      </div>
                      <div class="d-flex justify-content-center">
                        <button class="btn btn-outline-primary" @click.prevent="showEndSuspensionModal = false">Cancel</button>
                        <button class="btn btn-primary ml-2" @click.prevent="endSuspension(row.id);showEndSuspensionModal = false">Confirm</button>
                      </div>
                    </div>
                  </modal>
                </div>
                <div>
                  <button :class="['btn btn-sm mb-2 mb-lg-0 actions-remove', !processing ? row.is_suspend ? 'btn-primary actions-end_suspension' : 'btn-primary' : 'btn-primary-dark']" @click.prevent="removeModal">
                    {{ !processing ? 'Remove' : '' }}
                    <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
                  </button>
                  <modal v-if="showModal" @close="showModal = false">
                    <div slot="body">
                      <div class="alert alert-warning text-center">
                        You are about to remove the judge {{row.first_name}}.
                        Are you sure?
                      </div>
                      <div class="d-flex justify-content-center">
                        <button class="btn btn-outline-primary" @click.prevent="showModal = false">Cancel</button>
                        <button class="btn btn-primary ml-2" @click.prevent="remove(row.id);showModal = false">Confirm</button>
                      </div>
                    </div>
                  </modal>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </data-table>
    </div>
  </listing-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import axios from 'axios'
import listingLayout from '@/components/ListingLayout'
import dataTable from '@/components/DataTable'
// import tableButtonTemplate from '@/components/DataTableFields/Button'
import tableTextTemplate from '@/components/DataTableFields/Text'
import tableButtonTemplate from '@/components/DataTableFields/Button'
import modal from '@/components/Modal'
import eventBus from '@/store/EventBus.js'

export default {
  name: 'Members',
  props: ['success'],
  components: {
    'listing-layout': listingLayout,
    'data-table': dataTable,
    tableTextTemplate,
    modal
  },
  data() {
    return {
      error: '',
      rows: [],
      columns: [
        {
          label: 'First Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.first_name" :link="'Member Profile'" :slug="row.id" :row="row" :options="{ showLinks: true }" />`
          }),
          representedAs(row) { return `${row.first_name}` }
        },
        {
          label: 'Last Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.last_name" :link="'Member Profile'" :slug="row.id" :row="row" :options="{ showLinks: true, showActive: true }" />`
          }),
          representedAs(row) { return `${row.last_name}` }
        },
        {
          label: 'Phone number',
          field: 'judge_phone',
          filterable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate
              :text="row.judge_phone === null ? row.mobile_phone === null ? row.phone === null ? row.secondary_phone : row.phone : row.mobile_phone : row.judge_phone"
              :row="row" />`
          })
        },
        {
          label: 'Suburb',
          field: 'suburb',
          filterable: false,
          sortable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.suburb" :row="row" />`
          }),
          representedAs(row) { return `${row.suburb}` }
        },
        {
          label: 'Zone',
          field: 'zone_id',
          filterable: false,
          sortable: true,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="rowZone(row.zone_id)" :row="row" />`,
            methods: {
              rowZone(theID) {
                return this.$store.state.listZones.filter(zone => zone.id === theID).length ? this.$store.state.listZones.find(zone => zone.id === theID).code : 'Unspecified'
              }
            }
          })
        },
        {
          label: 'Judge Status',
          field: 'status',
          filterable: false,
          sortable: true,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.status.charAt(0).toUpperCase() + row.status.substring(1)" :row="row" />`
          })
        },
        {
          label: 'Actions',
          field: '',
          align: 'left',
          sortable: false,
          filterable: false,
          headerClass: 'd-none d-lg-table-cell column-lg-medium',
          visible: true,
          component: ({
            props: ['row'],
            components: { modal, tableButtonTemplate },
            data() {
              return {
                showModal: false,
                showSuspendModal: false,
                showEndSuspensionModal: false,
                processing: false
              }
            },
            methods: {
              removeModal() {
                this.showModal = true
              },
              suspendModal() {
                this.showSuspendModal = true
              },
              endSuspensionModal() {
                this.showEndSuspensionModal = true
              },
              remove(id) {
                this.processing = true
                axios.post(`${this.$api}/admin/judge-delete/${id}`).then((response) => {
                  this.processing = false
                  if (response.data.status === 'success') {
                    eventBus.$emit('removed')
                  }
                }).catch((error) => {
                  console.log(error)
                  this.error = 'Unable to receive data from the server. Please reload the page.'
                })
              },
              suspend(id) {
                this.processing = true
                axios.post(`${this.$api}/admin/judges/${id}/suspend`).then((response) => {
                  this.processing = false
                  if (response.data.status === 'success') {
                    eventBus.$emit('suspended')
                  } else {
                    this.error = 'Something went wrong. Please try again later.'
                  }
                }).catch((error) => {
                  console.log(error)
                  this.error = 'Unable to receive data from the server. Please reload the page.'
                })
              },
              endSuspension(id) {
                this.processing = true
                axios.post(`${this.$api}/admin/judges/${id}/end-suspension`).then((response) => {
                  this.processing = false
                  if (response.data.status === 'success') {
                    eventBus.$emit('end-suspension')
                  } else {
                    this.error = 'Something went wrong. Please try again later.'
                  }
                }).catch((error) => {
                  console.log(error)
                  this.error = 'Unable to receive data from the server. Please reload the page.'
                })
              }
            },
            template: `
              <div class="judges-list__actions">
                <div class="mr-1" v-if="!row.is_suspended">
                  <button :class="['btn btn-sm mb-2 mb-lg-0', !processing ? 'btn-primary actions-suspend' : 'btn-primary-dark']" @click.prevent="suspendModal">
                    {{ !processing ? 'Suspend' : '' }}
                    <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
                  </button>
                  <modal v-if="showSuspendModal" @close="showSuspendModal = false">
                    <div slot="body">
                      <div class="alert alert-warning text-center">
                        You are about to suspend the judge {{row.first_name}}.
                        Are you sure?
                      </div>
                      <div class="d-flex justify-content-center">
                        <button class="btn btn-outline-primary" @click.prevent="showSuspendModal = false">Cancel</button>
                        <button class="btn btn-primary ml-2" @click.prevent="suspend(row.id);showSuspendModal = false">Confirm</button>
                      </div>
                    </div>
                  </modal>
                </div>
                <div class="mr-1" v-else>
                  <button :class="['btn btn-sm mb-2 mb-lg-0', !processing ? 'btn-outline-primary actions-end_suspension' : 'btn-primary-dark']" @click.prevent="endSuspensionModal">
                    {{ !processing ? 'End Suspension' : '' }}
                    <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
                  </button>
                  <modal v-if="showEndSuspensionModal" @close="showEndSuspensionModal = false">
                    <div slot="body">
                      <div class="alert alert-warning text-center">
                        You are about to end suspension the judge {{row.first_name}}.
                        Are you sure?
                      </div>
                      <div class="d-flex justify-content-center">
                        <button class="btn btn-outline-primary" @click.prevent="showEndSuspensionModal = false">Cancel</button>
                        <button class="btn btn-primary ml-2" @click.prevent="endSuspension(row.id);showEndSuspensionModal = false">Confirm</button>
                      </div>
                    </div>
                  </modal>
                </div>
                <div>
                  <button :class="['btn btn-sm mb-2 mb-lg-0 actions-remove', !processing ? row.is_suspend ? 'btn-primary actions-end_suspension' : 'btn-primary' : 'btn-primary-dark']" @click.prevent="removeModal">
                    {{ !processing ? 'Remove' : '' }}
                    <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
                  </button>
                  <modal v-if="showModal" @close="showModal = false">
                    <div slot="body">
                      <div class="alert alert-warning text-center">
                        You are about to remove the judge {{row.first_name}}.
                        Are you sure?
                      </div>
                      <div class="d-flex justify-content-center">
                        <button class="btn btn-outline-primary" @click.prevent="showModal = false">Cancel</button>
                        <button class="btn btn-primary ml-2" @click.prevent="remove(row.id);showModal = false">Confirm</button>
                      </div>
                    </div>
                  </modal>
                </div>
              </div>`
          })
        }
      ],
      options: {
        search: true,
        loaded: false,
        filter: {
          is_suspended: [
            { name: 'All', value: 'all' },
            { name: 'Active', value: 0 },
            { name: 'Suspended', value: 1 }
          ]
        },
        activeFilter: {
          is_suspended: 'all',
          membership_status: 'all'
        }
      },
      showModal: false,
      showSuspendModal: false,
      showEndSuspensionModal: false,
      processing: false
    }
  },
  computed: {
    listZones() {
      return this.$store.state.listZones
    }
  },
  watch: {
    listZones() {
      if (this.listZones.length > 0) {
        this.rows.map((item) => {
          const tempItem = item
          tempItem.zone_name = this.listZones.filter(zone => zone.id === tempItem.zone_id).length > 0 ? this.listZones.filter(zone => zone.id === tempItem.zone_id)[0].code : 'Unspecified'
          return tempItem
        })
      }
    }
  },
  mounted() {
    this.$store.commit('deselectAllRows')
    this.getJudgesList()
  },
  methods: {
    rowZone(theID) {
      return this.$store.state.listZones.filter(zone => zone.id === theID).length ? this.$store.state.listZones.find(zone => zone.id === theID).code : 'Unspecified'
    },
    getJudgesList() {
      axios.get(`${this.$api}/admin/judges-list`).then((response) => {
        if (response.data.status === 'success') {
          this.error = ''
          const theRows = response.data.data
          if (this.listZones.length > 0) {
            theRows.map((item) => {
              const tempItem = item
              tempItem.zone_name = this.listZones.filter(zone => zone.id === tempItem.zone_id).length > 0 ? this.listZones.filter(zone => zone.id === tempItem.zone_id)[0].code : 'Unspecified'
              return tempItem
            })
          }
          this.rows = theRows
          this.options.loaded = true
        } else {
          this.error = 'Unable to receive data from the server. Please reload the page.'
        }
      })
    },
    removeModal() {
      this.showModal = true
    },
    suspendModal() {
      this.showSuspendModal = true
    },
    endSuspensionModal() {
      this.showEndSuspensionModal = true
    },
    remove(id) {
      this.processing = true
      axios.post(`${this.$api}/admin/judge-delete/${id}`).then((response) => {
        this.processing = false
        if (response.data.status === 'success') {
          eventBus.$emit('removed')
        }
      }).catch((error) => {
        console.log(error)
        this.error = 'Unable to receive data from the server. Please reload the page.'
      })
    },
    suspend(id) {
      this.processing = true
      axios.post(`${this.$api}/admin/judges/${id}/suspend`).then((response) => {
        this.processing = false
        if (response.data.status === 'success') {
          eventBus.$emit('suspended')
        } else {
          this.error = 'Something went wrong. Please try again later.'
        }
      }).catch((error) => {
        console.log(error)
        this.error = 'Unable to receive data from the server. Please reload the page.'
      })
    },
    endSuspension(id) {
      this.processing = true
      axios.post(`${this.$api}/admin/judges/${id}/end-suspension`).then((response) => {
        this.processing = false
        if (response.data.status === 'success') {
          eventBus.$emit('end-suspension')
        } else {
          this.error = 'Something went wrong. Please try again later.'
        }
      }).catch((error) => {
        console.log(error)
        this.error = 'Unable to receive data from the server. Please reload the page.'
      })
    }
  },
  created() {
    eventBus.$on('removed', () => {
      this.options.loaded = false
      this.rows = []
      this.success = 'The judge has been removed.'
      this.getJudgesList()
    })
  },
  updated() {
    eventBus.$on('suspended', () => {
      this.options.loaded = false
      this.rows = []
      this.success = 'The judge has been suspended.'
      this.getJudgesList()
    })
    eventBus.$on('end-suspension', () => {
      this.options.loaded = false
      this.rows = []
      this.success = 'The judge has been restored.'
      this.getJudgesList()
    })
  }
}
</script>

<style>
.judges-list__actions {
  display: flex;
}

.judges-list__actions .actions-end_suspension {
  width: 134px;
  padding: 0.125rem 8px !important;
  white-space: nowrap;
}

.judges-list__actions .actions-suspend {
  width: 134px;
}

@media (max-width: 1220px) {

  .judges-list__actions {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .judges-list__actions > div {
    margin-bottom: 4px;
  }

  .judges-list__actions > div:last-of-type {
    margin-bottom: 0;
  }

  .judges-list__actions .actions-suspend {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Judges/Admin/AdminJudgesList.vue